import {replace} from 'lodash';
import numeral from 'numeral';
import {currencySymbol, ECurrency} from "@/models/general";
import moment from "moment";

// ----------------------------------------------------------------------

export function fCurrency2VND(number?: number | string) {
  return numeral(number || 0).format('0,0');
}

export function fPercent(number: number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number: number | string) {
  return numeral(number).format();
}

export function fShortenNumber(number: number | string) {
  return replace(numeral(number).format('0.00a'), '.00', '');
}

export function fCurrency(number: number | string) {
  return `${currencySymbol[ECurrency.USD].first}${numeral(number || 0).format(Number.isInteger(number || 0) ? '0,0' : '0,0.00')} ${currencySymbol[ECurrency.USD].last}`
}

export function fCurrencyVND(number?: number | string) {
  return `${currencySymbol[ECurrency.VND].first}${numeral(number || 0).format('0,0')} ${currencySymbol[ECurrency.VND].last}`
}

export function fCurrencyIDR(number: number | string) {
  return `${currencySymbol[ECurrency.IDR].first}${numeral(number || 0).format(Number.isInteger(number || 0) ? '0,0' : '0,0.00')} ${currencySymbol[ECurrency.IDR].last}`
}

export function fData(number: number | string) {
  return numeral(number).format('0.0 b');
}

export function round(number: number) {
  return Math.round(number * 100) / 100
}

const ordinals: string[] = ['th', 'st', 'nd', 'rd'];
export const formatOrdinalumbers = (n: number, language?: string) => {
  const v = n % 100;
  return (language === 'en' ? n + (ordinals[(v - 20) % 10] || ordinals[v] || ordinals[0]) : n);
}

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + " B";
  const k = 1024;
  const sizes = ["KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = (bytes / Math.pow(k, i)).toFixed(2);
  return `${value} ${sizes[i - 1]}`;
}

export const formatDate = (date: string, locale: string) => {
  const now = moment();
  const inputDate = moment(date);
  const diffDays = now.diff(inputDate, 'days');
  switch (diffDays) {
    case 0:
      return locale === 'en' ? 'Today'
        : locale === 'vi' ? 'Hôm nay'
          : locale === 'id' ? 'Hari ini'
            : 'Hoy';
    case 1:
      return locale === 'en' ? '1 day ago'
        : locale === 'vi' ? '1 ngày trước'
          : locale === 'id' ? '1 hari yang lalu'
            : 'Hoy';
    case 2:
      return locale === 'en' ? '2 days ago'
        : locale === 'vi' ? '2 ngày trước'
          : locale === 'id' ? '2 hari yang lalu'
            : 'Hoy';
    case 3:
      return locale === 'en' ? '3 days ago'
        : locale === 'vi' ? '3 ngày trước'
          : locale === 'id' ? '3 hari yang lalu'
            : 'Hoy';
    default: {
    const dateObj = new Date(date);
    if (!date || isNaN(dateObj.getTime())) return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(new Date());
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(dateObj);
    }
    
  }
};
